import { useFormFieldValue } from '../../../../../../taboola-common-frontend-modules/formData';
import { useCampaignBudgetRestrictions } from '../../BudgetSectionSponsored/hooks/useCampaignBudgetRestrictions';

export const useCampaignsGroupBudgetDistributionMethod = () => {
    const { campaignGroup } = useCampaignBudgetRestrictions();

    const { value: campaignsGroupBudgetDistributionMethod, onChange: onBudgetDistributionMethodChange } =
        useFormFieldValue({ field: 'campaignGroupInfo.campaignsGroupBudgetDistributionMethod' }, { campaignGroup });

    return { campaignsGroupBudgetDistributionMethod, onBudgetDistributionMethodChange };
};
